/* eslint-disable import/prefer-default-export */
import API from 'api';
import _logger from 'utils/logger';
import formatValues from 'utils/formatValues';
import Moment from 'moment';
import { ID_ENTIDAD } from 'utils/env';
import { formatReceived } from 'utils/formatters';
import { setCategoriasDeQuejas, setMotivosDeQuejas, setSubMotivosDeQuejas } from 'store/catalogos';
import store from 'store/store';

const baseURI = '/solicitudes/';
// /solicitudes/quejas-public/
export const getQueja = async (params = {}) => {
  try {
    const response = await API.get(`${baseURI}quejas/`, { params });
    return formatReceived(response.data);
  } catch (error) {
    _logger(error);
  }
  return false;
};

export const postQueja = async (values = null) => {
  try {
    const formattedValues = {
      ...formatValues(values),
      hora_de_los_hechos: Moment(values.hora_de_los_hechos).format('HH:mm:ss'),
      entidad: ID_ENTIDAD,
    };

    const response = await API.post(`${baseURI}quejas/`, formattedValues);
    return response.data;
  } catch (error) {
    _logger(error);
  }
  return false;
};

export const getCategoriasDeQuejas = async (dispatch) => {
  try {
    const { categoriasDeQuejas } = store.getState().catalogos;
    if (categoriasDeQuejas.length) return categoriasDeQuejas;
    const response = await API.get(`${baseURI}categorias-de-las-quejas/`);
    dispatch(setCategoriasDeQuejas(response.data));
    return response.data;
  } catch (error) {
    _logger(error);
  }
  return [];
};

export const getMotivosDeQuejas = async (dispatch) => {
  try {
    const { motivosDeQuejas } = store.getState().catalogos;
    if (motivosDeQuejas.length) return motivosDeQuejas;

    const response = await API.get(`${baseURI}motivos-de-las-quejas/`);
    dispatch(setMotivosDeQuejas(response.data));
    return response.data;
  } catch (error) {
    _logger(error);
  }
  return [];
};

export const postTestigos = async (quejaId, values = null) => {
  try {
    const response = await API.post(`${baseURI}testigos-de-quejas-public/`, {
      ...values,
      queja: quejaId,
    });
    return response.data;
  } catch (error) {
    _logger(error);
  }
  return false;
};

export const postEvidencias = async (values = null) => {
  try {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    const response = await API.post(`${baseURI}archivos-de-quejas/`, values, config);
    return response.data;
  } catch (error) {
    _logger(error);
  }
  return false;
};

export const getSubmotivos = async (dispatch) => {
  try {
    const { subMotivosDeQuejas } = store.getState().catalogos;
    if (subMotivosDeQuejas.length) return subMotivosDeQuejas;
    const response = await API.get(`${baseURI}sub-motivos-de-quejas-public/`);
    dispatch(setSubMotivosDeQuejas(response.data));
    return response.data;
  } catch (error) {
    _logger(error);
  }
  return [];
};
